import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Collections from "../pages/collections/page";
import TimelinePage from "../pages/timeline/page";
import Article from "../pages/article/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/collections",
    element: <Collections />,
  },
  {
    path: "/timeline",
    element: <TimelinePage />,
  },
  {
    path: "/article/:slug",
    element: <Article />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;